'use client';

import { Box, styled, useColorScheme } from '@mui/material';
import Image, { type StaticImageData } from 'next/image';
import { forwardRef, type ComponentProps } from 'react';

import { ApplicationsLogos } from '@/assets/logos/applications';

const _CircleImage = forwardRef<
  HTMLSpanElement,
  {
    alt: string;
    src: StaticImageData;
    srcDark?: StaticImageData;
    contrast?: boolean;
  } & ComponentProps<typeof Box>
>(({ alt, src, srcDark, contrast, ...props }, ref) => {
  const { mode } = useColorScheme();
  const resolvedSrc = mode === 'dark' && srcDark ? srcDark : src;
  // TODO: amir - return when the application logos are fixed
  // if (!src) {
  // captureMessage(
  //   `Could not find src for application logo: ${alt}`,
  //   'warning'
  // );
  // }

  return (
    <Box component='span' ref={ref} {...props}>
      <Image
        alt={alt}
        src={resolvedSrc || ApplicationsLogos.Unknown}
        width={24}
        height={24}
        style={{ width: '24px', height: '24px' }}
      />
    </Box>
  );
});

export const CircleImage = styled(_CircleImage)((props) => ({
  width: '24px',
  height: '24px',
  minHeight: '24px',
  minWidth: '24px',
  backgroundColor: props.contrast
    ? 'var(--mui-palette-background-default)'
    : 'transparent',
  ...props.theme.applyStyles('dark', {
    backgroundColor: !props.contrast
      ? 'var(--mui-palette-background-default)'
      : 'transparent',
  }),
  display: 'inline-flex',
  borderRadius: '50%',
  marginRight: '8px',

  ':last-of-type': {
    marginRight: 0,
  },
}));
